import { FONTS } from '../constants';
import { FontFamily } from '../models';

const weightMapping: Record<'Regular' | 'Bold' | 'SemiBold', FontWeight> = {
  Regular: '400Regular',
  Bold: '700Bold',
  SemiBold: '600SemiBold',
};

export const getFontFamily = (
  fontFamily: FontFamily,
  weight: 'Regular' | 'Bold' | 'SemiBold',
): string => {
  const weightKey = weightMapping[weight];
  const fontKey = `${fontFamily}_${weightKey}`;
  return FONTS[fontKey as keyof typeof FONTS];
};

type FontWeight = '400Regular' | '700Bold' | '600SemiBold';

export const generateFontVariantsForRenderingRawHTML = (
  fontName: FontFamily,
): string[] => {
  return [getFontFamily(fontName, 'Regular'), getFontFamily(fontName, 'Bold')];
};
